export enum InstallmentStatus {
  ON_TIME = 'on_time',
  OVERDUE = 'overdue',
}

export enum InstallmentStatusFromApi {
  FULLY_PAID = 'instFullyPaid',
}

export enum InstallmentStatuses {
  NO_INSTALLMENT_FOUND = 'no-installment-found',
  NO_POLICY_FOUND = 'no-policy-found',
  POLICY_DOWNGRADED = 'policy-downgraded',
  INSTALLMENT_PAID = 'installment-paid',
  PAYMENT_RESULT = 'payment-result',
}
